import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Calendar, Clock, Shield, Video } from 'lucide-react';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Hero Section */}
      <div className="relative bg-white border-b border-slate-200">
        <div className="container mx-auto px-4 py-20 md:py-32">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-manrope font-bold text-slate-900 mb-6 leading-tight" data-testid="hero-heading">
              Healthcare Appointments
              <br />
              <span className="text-primary">Made Simple</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-600 mb-8 leading-relaxed font-inter">
              Book appointments with top doctors, manage your health records, and get video consultations from the comfort of your home.
            </p>
            <div className="flex gap-4 justify-center flex-wrap">
              <Button
                size="lg"
                className="px-8 py-6 text-lg"
                onClick={() => navigate('/book')}
                data-testid="book-appointment-cta"
              >
                Book Appointment
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="px-8 py-6 text-lg"
                onClick={() => navigate('/register')}
                data-testid="register-cta"
              >
                Get Started
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container mx-auto px-4 py-20">
        <h2 className="text-3xl md:text-4xl font-manrope font-bold text-center mb-12" data-testid="features-heading">
          Why Choose Booking Vedamrita
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            {
              icon: Calendar,
              title: 'Easy Booking',
              description: 'Book appointments in just a few clicks',
              testId: 'feature-booking'
            },
            {
              icon: Clock,
              title: 'Real-time Slots',
              description: 'View and book available time slots instantly',
              testId: 'feature-slots'
            },
            {
              icon: Video,
              title: 'Video Consultations',
              description: 'Connect with doctors via secure video calls',
              testId: 'feature-video'
            },
            {
              icon: Shield,
              title: 'Secure & Private',
              description: 'Your health data is protected and confidential',
              testId: 'feature-security'
            },
          ].map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-xl p-6 border border-slate-200 card-hover"
                data-testid={feature.testId}
              >
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                  <Icon className="h-6 w-6 text-primary" />
                </div>
                <h3 className="text-xl font-manrope font-semibold mb-2">{feature.title}</h3>
                <p className="text-slate-600 font-inter">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-primary text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-manrope font-bold mb-4" data-testid="cta-heading">
            Ready to Get Started?
          </h2>
          <p className="text-lg mb-8 text-primary-foreground/90">
            Join thousands of patients who trust Booking Vedamrita for their healthcare needs
          </p>
          <Button
            size="lg"
            variant="secondary"
            className="px-8 py-6 text-lg"
            onClick={() => navigate('/register')}
            data-testid="bottom-cta"
          >
            Create Account
          </Button>
        </div>
      </div>
    </div>
  );
}